/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Collaborators_Nrolesremoved2Inputs */

const en_settings_collaborators_nrolesremoved2 = /** @type {(inputs: Settings_Collaborators_Nrolesremoved2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} removed`)
};

/**
* | output |
* | --- |
* | "{count} removed" |
*
* @param {Settings_Collaborators_Nrolesremoved2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_nrolesremoved2 = /** @type {((inputs: Settings_Collaborators_Nrolesremoved2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Nrolesremoved2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_nrolesremoved2(inputs)
});
export { settings_collaborators_nrolesremoved2 as "settings_collaborators_nRolesRemoved" }